<template>
  <div id="app">
    <main-video></main-video>
  </div>
</template>

<script>
import MainVideo from "./components/MainVideo.vue";

export default {
  name: "App",
  mounted() {
    function fullScreenFun() {
      var iFullscreen = false; //当前是否全屏状态
      var fullscreenEnabled =
        document.fullscreenEnabled ||
        document.mozFullScreenEnabled ||
        document.webkitFullscreenEnabled ||
        document.msFullscreenEnabled;
      if (fullscreenEnabled) {
        let de = document.documentElement;
        if (iFullscreen) {
          //关闭全屏
          if (document.exitFullscreen) {
            document.exitFullscreen();
          } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
          } else if (document.webkitCancelFullScreen) {
            document.webkitCancelFullScreen();
          }
        } else {
          //打开全屏
          if (de.requestFullscreen) {
            // de.requestFullscreen();
          } else if (de.mozRequestFullScreen) {
            // de.mozRequestFullScreen();
          } else if (de.webkitRequestFullScreen) {
            // de.webkitRequestFullScreen();
          }
        }
      } else {
        console.log("浏览器当前不能全屏");
      }
    }
    fullScreenFun();
  },
  components: {
    MainVideo,
  },
};
</script>

<style>
*,
*:before,
*:after {
  margin: 0;
  box-sizing: border-box;
}
html {
  background-color: #245380;
  overflow: hidden;
  user-select: none;
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100vh;
}
</style>
